// handleSaveWorkspaceDefaults — validates, sanitizes, and persists workspace
// data-entry default settings to Firestore. Tracks its own saving state.

import React from 'react';
import { sanitizeWorkspaceDataEntrySettings } from '../config/workspaceDefaults';
import * as workspaceService from '../services/workspaceService';

export function useWorkspaceDefaultsHandler({
    user,
    selectedWorkspaceId,
    showToast,
    setWorkspaceDataEntrySettings,
}) {
    const [isSavingWorkspaceDefaults, setIsSavingWorkspaceDefaults] = React.useState(false);

    const handleSaveWorkspaceDefaults = async (updates = {}) => {
        if (!user || !selectedWorkspaceId) {
            showToast('Select a team before updating defaults.', 'error');
            return;
        }
        const sanitized = sanitizeWorkspaceDataEntrySettings(updates);
        try {
            setIsSavingWorkspaceDefaults(true);
            await workspaceService.updateWorkspaceSettings(selectedWorkspaceId, {
                dataEntryDefaults: sanitized,
                updatedAt: Date.now()
            });
            setWorkspaceDataEntrySettings(sanitized);
            showToast('Team defaults updated.');
        } catch (error) {
            console.error('Failed to save team defaults:', error);
            showToast(`Failed to save team defaults: ${error?.message || 'Unknown error'}`, 'error');
            throw error;
        } finally {
            setIsSavingWorkspaceDefaults(false);
        }
    };

    return { handleSaveWorkspaceDefaults, isSavingWorkspaceDefaults };
}
